import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { DialogComponent } from '@app/components/dialog/dialog.component';
import { VideoModalComponent } from '@app/components/video-modal/video-modal.component';
import { CustomDialogConfig } from '@app/interfaces/dialog-config.interface';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private readonly cdkDialog: Dialog = inject(Dialog);

  public showDialog(customConfig: CustomDialogConfig): void {
    const dialogConfig = {
      hasBackdrop: true,
      height: '400px',
      width: '600px',
      data: customConfig
    };
    this.cdkDialog.open(DialogComponent, dialogConfig);
  }

  public showVideoModal(title: string, videoUrl: string): void {
    const dialogConfig = {
      hasBackdrop: true,
      width: '900px',
      maxWidth: '90vw',
      panelClass: 'video-modal-dialog',
      data: { title, videoUrl }
    };
    this.cdkDialog.open(VideoModalComponent, dialogConfig);
  }
}
